// 打包 antd 1.12 版本
//require('antd/dist/antd.css');

// 在此处导出所有组件，方便将 weax 发布成第三方模块
function camelCase(name) {
  return (
    name.charAt(0).toUpperCase() +
    name.slice(1).replace(/-(\w)/g, (m, n) => {
      return n.toUpperCase();
    })
  );
}

const req = require.context(
  "./src/components",
  true,
  /^\.\/[^_][\w-]+\/(style\/)?index\.js?$/
);
req.keys().forEach(mod => {
  const v = req(mod);
  const match = mod.match(/^\.\/([^_][\w-]+)\/index\.js?$/);
  if (match && match[1]) {
    try {
      const name = camelCase(match[1]);
      exports[name] = v.default || v;
    } catch (e) {
      console.log(e);
    }
  }
});
